<template>
  <span>
    <i v-if="!isResolved && !unableToResolve" class="fa fa-spinner fa-pulse fa-xs"></i>
    <i v-else-if="unableToResolve" class="fa fa-exclamation-triangle text-danger fa-xs"></i>
    {{ convertedElevationValue }}
  </span>
</template>

<script>
  import _ from 'lodash';
  import axios from '../packs/axios_client';

  export default {
    created: function() {
      if (this.isResolved) return;

      this.resolveElevation();
    },

    computed: {
      convertedElevationValue: function () {
        if (this.metric) return this.value.toLocaleString();

        return _.round(this.value / 0.3048).toLocaleString();
      }
    },

    data: function () {
      return {
        value: this.elevationValue,
        isResolved: this.resolved || false,
        unableToResolve: false
      }
    },

    methods: {
      // Returns the request promise so a caller can wait on it — the polling
      // path below chains onto itself, and without a handle the "invalid
      // response" throw is unobservable.
      resolveElevation: function () {
        return axios.get(
          this.apiEndpoint,
          { headers: { 'Accept': 'application/json', 'Authorization': `Bearer ${this.apiToken}` } }
        ).then(response => {
          if (response.data[this.responseKey]) {
            if (response.data[this.responseKey]['elevation_processing_completed']) {
              this.value = response.data[this.responseKey][this.attributeKey];
              this.isResolved = true;
            } else {
              setTimeout(this.resolveElevation, 1000);
            }
          } else {
            throw "Response from server invalid";
          }
        })
      }
    },

    props: ['resolved', 'elevationValue', 'apiEndpoint', 'metric', 'responseKey', 'apiToken', 'attributeKey']
  }
</script>
